// src/store/productManagment/reducer.ts

import {
  FETCH_PRODUCT_REQUEST,
  FETCH_PRODUCT_SUCCESS,
  FETCH_PRODUCT_FAILURE,
  FETCH_PRODUCT_BY_ID_REQUEST,
  FETCH_PRODUCT_BY_ID_SUCCESS,
  FETCH_PRODUCT_BY_ID_FAILURE,
  FETCH_PRODUCT_BY_CATEGORY_REQUEST,
  FETCH_PRODUCT_BY_CATEGORY_SUCCESS,
  FETCH_PRODUCT_BY_CATEGORY_FAILURE,
  ProductState,
  initialState,
  ProductActionTypes
} from './types';

const productListReducer = (state = initialState, action: ProductActionTypes): ProductState => {
  switch (action.type) {
    case FETCH_PRODUCT_REQUEST:
    case FETCH_PRODUCT_BY_ID_REQUEST:
    case FETCH_PRODUCT_BY_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_PRODUCT_SUCCESS: {
      const productMap = new Map(state.products);
      action.payload.products.forEach(product => {
        productMap.set(product.id, product);
      });
      return {
        ...state,
        loading: false,
        products: productMap,
        lastFetchTimestamp: action.payload.lastFetchTimestamp,
        lastFetchParams: action.payload.lastFetchParams
      };
    }

    case FETCH_PRODUCT_BY_ID_SUCCESS:
    case FETCH_PRODUCT_BY_CATEGORY_SUCCESS: {
      const productMap = new Map(state.products);
      if (Array.isArray(action.payload)) {
        action.payload.forEach(product => {
          productMap.set(product.id, product);
        });
      } else {
        productMap.set(action.payload.id, action.payload);
      }
      return {
        ...state,
        loading: false,
        products: productMap,
        lastFetchTimestamp: Date.now()
      };
    }

    case FETCH_PRODUCT_FAILURE:
    case FETCH_PRODUCT_BY_ID_FAILURE:
    case FETCH_PRODUCT_BY_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default productListReducer;